export default __webpack_public_path__ + "static/media/Action_knockingdoor.5808b31a.wav";